import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './partage/components/login/login.component';
import { RolesAcces } from './partage/components/login/roles-utilisateur.service';
import { rolesGuard } from './partage/guards/roles.guard';
import { pasDEcritureEnCoursGuard } from './partage/guards/ecriture-en-cours.guard';
import { PageNotFoundComponent } from './partage/components/page-not-found/page-not-found.component';
import { ListeClientsRouteComponent } from './routes/clients/liste-clients/liste-clients.route.component';
import { ListeClientsService } from './routes/clients/liste-clients/liste-clients.service';
import { FactureService } from './routes/facturation/facture.service';
import { CommissionsRouteComponent } from './routes/parametrage/commissions/commissions.route.component';
import { CommissionsService } from './routes/parametrage/commissions/commissions.service';
import { RapprochementManuelRouteComponent } from './routes/rapprochement/rapprochement-manuel/rapprochement-manuel.route.component';
import { RapprochementManuelService } from './routes/rapprochement/rapprochement-manuel/rapprochement-manuel.service';
import { EvenementsRouteComponent } from './routes/redditions/evenements/evenements.route.component';
import { EvenementsService } from './routes/redditions/evenements/evenements.service';
import { FormulesRouteComponent } from './routes/redditions/formules/formules.route.component';
import { FormulesService } from './routes/redditions/formules/formules.service';
import { FichierSapRouteComponent } from './routes/redditions/fichier-sap/fichier-sap.route.component';
import { ouvrirFichierSapGuard } from './routes/redditions/fichier-sap/ouvrir-fichier-sap.guard';
import { VersionComponent } from './routes/version/version.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      /* Galerie des composants du design system. Chargee paresseusement et
         gardee par `environment.showComponentsGallery` : en production la route
         ne matche jamais. Reference vivante des composants disponibles. */
      {
        // Chemin impose par le kit : son entree de menu dev pointe sur `/components`.
        path: 'components',
        loadChildren: () =>
          import('./dev/components-gallery/components-gallery.routes').then(m => m.COMPONENTS_GALLERY_ROUTES),
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'redditions/evenements',
        component: EvenementsRouteComponent,
        canActivate: [MsalGuard, rolesGuard(...RolesAcces.comptabilite)],
        canDeactivate: [pasDEcritureEnCoursGuard],
        providers: [EvenementsService, FactureService],
      },
      {
        path: 'redditions/formules',
        component: FormulesRouteComponent,
        canActivate: [MsalGuard, rolesGuard(...RolesAcces.comptabilite)],
        canDeactivate: [pasDEcritureEnCoursGuard],
        providers: [FormulesService, FactureService],
      },
      {
        // `ouvrirFichierSapGuard` ouvre la modale d'export et annule la
        // navigation : l'ecran courant reste affiche derriere, et le composant
        // ci-dessous — exige par Angular sur une route feuille — n'est jamais rendu.
        path: 'redditions/fichier-sap',
        component: FichierSapRouteComponent,
        canActivate: [MsalGuard, rolesGuard(...RolesAcces.comptabilite), ouvrirFichierSapGuard],
      },
      {
        path: 'rapprochement/rapprochement-manuel',
        component: RapprochementManuelRouteComponent,
        canActivate: [MsalGuard, rolesGuard(...RolesAcces.comptabilite)],
        canDeactivate: [pasDEcritureEnCoursGuard],
        providers: [RapprochementManuelService],
      },
      {
        path: 'version',
        component: VersionComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'rapprochement/rapport/telecharger',
        redirectTo: 'rapprochement/rapprochement-manuel',
      },
      {
        path: 'parametrage/commissions',
        component: CommissionsRouteComponent,
        canActivate: [MsalGuard, rolesGuard(...RolesAcces.comptabilite)],
        canDeactivate: [pasDEcritureEnCoursGuard],
        providers: [CommissionsService],
      },
      {
        path: 'clients/liste-clients',
        component: ListeClientsRouteComponent,
        canActivate: [MsalGuard, rolesGuard(...RolesAcces.clients)],
        canDeactivate: [pasDEcritureEnCoursGuard],
        providers: [ListeClientsService],
      },
      { path: '**', component: PageNotFoundComponent },
    ],
  },
];
